import React from 'react';
import {
  // Font Awesome - storesnės, geresnė įskaitomumas
  FaTh,
  FaClipboardList,
  FaBox,
  FaFileInvoice,
  FaWallet,
  FaChartBar,
  FaThLarge,
  FaTag,
  FaBolt,
  FaStar,
  FaGift,
  FaTruck,
  FaCreditCard,
  FaEnvelope,
  FaFileAlt,
  FaStore,
  FaHome,
  FaCloudUploadAlt,
  FaExclamationTriangle,
  FaCog,
  FaPlus,
  FaChartPie,
  FaUsers,
  // Status icons
  FaCheckCircle,
  FaTimesCircle,
  FaInfoCircle,
  // Actions
  FaEye,
  FaRedo,
  FaDownload,
  FaTimes,
  FaEdit,
  FaTrash,
  FaCheck,
  FaBan,
  FaCopy,
} from 'react-icons/fa';

// ============================================
// PAGRINDINĖS MENIU IKONOS
// ============================================

export const DashboardIcon = () => <FaTh size={20} />;

export const OrdersIcon = () => <FaClipboardList size={20} />;

export const ProductsIcon = () => <FaBox size={20} />;

export const InvoicesIcon = () => <FaFileInvoice size={20} />;

export const StoreCreditsIcon = () => <FaWallet size={20} />;

export const FinanceIcon = () => <FaChartBar size={20} />;

export const CategoriesIcon = () => <FaThLarge size={20} />;

export const CouponsIcon = () => <FaTag size={20} />;

export const PromotionsIcon = () => <FaBolt size={20} />;

export const LoyaltyIcon = () => <FaStar size={20} />;

export const GiftCardsIcon = () => <FaGift size={20} />;

export const ShippingIcon = () => <FaTruck size={20} />;

export const PaymentIcon = () => <FaCreditCard size={20} />;

export const EmailIcon = () => <FaEnvelope size={20} />;

export const PagesIcon = () => <FaFileAlt size={20} />;

export const MarketplaceIcon = () => <FaStore size={20} />;

export const HomeIcon = () => <FaHome size={20} />;

export const BackupIcon = () => <FaCloudUploadAlt size={20} />;

export const ErrorIcon = () => <FaExclamationTriangle size={20} />;

export const SettingsIcon = () => <FaCog size={20} />;

export const AddIcon = () => <FaPlus size={20} />;

export const ReportsIcon = () => <FaChartPie size={20} />;

// ============================================
// STATISTIKOS IKONOS
// ============================================

export const UsersStatIcon = () => <FaUsers size={20} />;

// ============================================
// STATUS IKONOS (Pranešimams, modalam)
// ============================================

export const SuccessIcon = () => <FaCheckCircle size={20} />;

export const ErrorIconFlat = () => <FaTimesCircle size={20} />;

export const WarningIcon = () => <FaExclamationTriangle size={20} />;

export const InfoIcon = () => <FaInfoCircle size={20} />;

// ============================================
// VEIKSMŲ IKONOS
// ============================================

export const ViewIcon = () => <FaEye size={16} />;

export const ReturnIcon = () => <FaRedo size={16} />;

export const DownloadIcon = () => <FaDownload size={16} />;

export const CloseIcon = () => <FaTimes size={16} />;

export const EditIcon = () => <FaEdit size={16} />;

export const DeleteIcon = () => <FaTrash size={16} />;

export const ActivateIcon = () => <FaCheck size={16} />;

export const DeactivateIcon = () => <FaBan size={16} />;

export const CopyIcon = () => <FaCopy size={16} />;

// ============================================
// PAGALBINĖS FUNKCIJOS
// ============================================

/**
 * Grąžina ikonos komponentą pagal ikonos pavadinimą
 * @param {string} iconName - Ikonos pavadinimas
 * @returns {React.Component|null} - Ikonos komponentas arba null
 */
export const getIcon = (iconName) => {
  switch (iconName) {
    // Pagrindinės meniu ikonos
    case 'dashboard':
      return <DashboardIcon />;
    case 'orders':
      return <OrdersIcon />;
    case 'products':
      return <ProductsIcon />;
    case 'invoices':
      return <InvoicesIcon />;
    case 'storeCredits':
      return <StoreCreditsIcon />;
    case 'finance':
      return <FinanceIcon />;
    case 'categories':
      return <CategoriesIcon />;
    case 'coupons':
      return <CouponsIcon />;
    case 'promotions':
      return <PromotionsIcon />;
    case 'loyalty':
      return <LoyaltyIcon />;
    case 'giftCards':
      return <GiftCardsIcon />;
    case 'shipping':
      return <ShippingIcon />;
    case 'payment':
      return <PaymentIcon />;
    case 'email':
      return <EmailIcon />;
    case 'pages':
      return <PagesIcon />;
    case 'marketplace':
      return <MarketplaceIcon />;
    case 'home':
      return <HomeIcon />;
    case 'backup':
      return <BackupIcon />;
    case 'error':
      return <ErrorIcon />;
    case 'settings':
      return <SettingsIcon />;
    case 'add':
      return <AddIcon />;
    case 'reports':
      return <ReportsIcon />;
    
    // Statistika
    case 'usersStat':
      return <UsersStatIcon />;
    
    // Status ikonos
    case 'success':
      return <SuccessIcon />;
    case 'errorFlat':
      return <ErrorIconFlat />;
    case 'warning':
      return <WarningIcon />;
    case 'info':
      return <InfoIcon />;
    
    // Veiksmų ikonos
    case 'view':
      return <ViewIcon />;
    case 'return':
      return <ReturnIcon />;
    case 'download':
      return <DownloadIcon />;
    case 'close':
      return <CloseIcon />;
    case 'edit':
      return <EditIcon />;
    case 'delete':
      return <DeleteIcon />;
    case 'activate':
      return <ActivateIcon />;
    case 'deactivate':
      return <DeactivateIcon />;
    
    default:
      return null;
  }
};

// ============================================
// DEFAULT EXPORT
// ============================================

const Icons = {
  // Pagrindinės meniu ikonos
  DashboardIcon,
  OrdersIcon,
  ProductsIcon,
  InvoicesIcon,
  StoreCreditsIcon,
  FinanceIcon,
  CategoriesIcon,
  CouponsIcon,
  PromotionsIcon,
  LoyaltyIcon,
  GiftCardsIcon,
  ShippingIcon,
  PaymentIcon,
  EmailIcon,
  PagesIcon,
  MarketplaceIcon,
  HomeIcon,
  BackupIcon,
  ErrorIcon,
  SettingsIcon,
  AddIcon,
  ReportsIcon,
  
  // Statistika
  UsersStatIcon,
  
  // Status ikonos
  SuccessIcon,
  ErrorIconFlat,
  WarningIcon,
  InfoIcon,
  
  // Veiksmų ikonos
  ViewIcon,
  ReturnIcon,
  DownloadIcon,
  CloseIcon,
  EditIcon,
  DeleteIcon,
  ActivateIcon,
  DeactivateIcon,
  
  // Pagalbinės funkcijos
  getIcon,
};

export default Icons;
